import {useGameServerConnection, useLoadingState, useScene} from '@glark-newco/game-library';
import {Sprite} from '@pixi/react';
import {sound} from '@pixi/sound';
import {Assets} from 'pixi.js';
import {Suspense, useEffect, useMemo} from 'react';
import {GAME_BACKGROUND, OVERLAY} from './assetManifest';
import {Design} from './scenes/Design';
import {Lobby} from './scenes/Lobby';
import {Play} from './scenes/Play';
import {PreLoader} from './scenes/PreLoader';
import {Register} from './scenes/Register';
import {Review} from './scenes/Review';
import {useActiveEditMode, useIsLinkCreationActive} from './state/networkEditStore';
import './SupplyChainCanvas.css';
import {useDesignActive} from './state/uiStore';

export function SupplyChainCanvas() {
    const [loadingState] = useLoadingState();
    const scene = useScene();
    const {connectionReady} = useGameServerConnection();
    const activeEditMode = useActiveEditMode();
    const designModeActive = useDesignActive();
    const isLinkCreationActive = useIsLinkCreationActive();

    const pixiScene = useMemo(() => {
        if (loadingState === 'PRELOAD')
            return <PreLoader/>;
        else if (!connectionReady)
            return <Register/>;
        else if (scene === 'LOBBY' && designModeActive)
            return (
                <Suspense
                    fallback={<>
                        <Sprite texture={Assets.get(GAME_BACKGROUND)}/>
                        <Sprite texture={Assets.get(OVERLAY)}/>
                    </>}
                >
                    <Design/>
                </Suspense>
            );
        else if (scene === 'LOBBY' && !designModeActive)
            return <Lobby/>;
        else if (scene === 'PLAY')
            return <Play/>;
        else
            return <Review/>;
    }, [loadingState, scene, connectionReady, designModeActive]);

    useEffect(() => {
        // For adding cursor when adding player/link
        const gameCanvas = document.querySelector('.gameCanvas');
        if (!gameCanvas) return;
    
        gameCanvas.classList.remove('cursor-add-link', 'cursor-add-player');
    
        if (isLinkCreationActive) {
            gameCanvas.classList.add('cursor-add-link');
        } else if (activeEditMode === 'addPlayer') {
            gameCanvas.classList.add('cursor-add-player');
        }
    }, [designModeActive, activeEditMode, isLinkCreationActive]);

    useEffect(() => {
        sound.disableAutoPause = true;
    }, []);

    return (
        <>
            {pixiScene}
        </>
    );
}
